import * as SEQ from "@/api/sequence";
import { getIsAccessDisabled } from "@/utils/permissions";
import _ from "lodash";

const state = {
  sequence_list_access_code: null,
  sequence_labels_access_code: null,
  sequence_templates_access_code: null,
  sequence_credentials_access_code: null,
  sequence_schedules_access_code: null,
  open_wizard: false,
  /** sequence detail store */
  current_detail_sequence_info: null,
  current_detail_sequence_steps: null,
  current_detail_cached_version: { workflow: null, settings: null },
  show_broken_step_save_warning_dialog: false,
  show_broken_step_disable_activation_warning_dialog: false,
  // for broken steps warning dialog, the unsaved params for saving function
  current_detail_unsaved_params_of_broken_steps: null,
  broken_step_save_confirm_callback: null,

  sequenceRequestController: null,
  sequenceLabelRequestController: null,
  /** sequence labels start */
  sequenceLabelListLoading: false,
  sequenceLabelList: [],
  /** sequence labels end */
  /** sequence template start */
  templateChannelsLoading: false,
  templateChannels: [],
  templateChannelsObject: {},
  allTemplatesLoading: false,
  allTemplates: [],
  allTemplatesController: null,

  /** sequence template end */
  /** sequence credential start */
  credentialChannelsLoading: false,
  credentialChannels: [],
  allCredentialsLoading: false,
  allCredentials: null,
  /** sequence credential end */
  /** sequence workflow start */
  nodeChannelsLoading: false,
  nodeChannels: [],
  nodeChannelsObject: {},
  /** sequence workflow end */

  /** -------------------------- */
  inboxLoading: false,
  stepsList: [],
  stepsListLoading: false,
  isShow: true,
  sequence_loading: false,
  inboxList: [],
  inboxCategoryList: [],
  inboxStatusNum: [],
  contactStatus: [],
  messageStatus: [],
  accountEmailList: { channel_email_accounts: [], pagination: {} },
  seqChannelTypes: [],
  scheduleList: [],
  sequenceList: {
    seqData: [],
    pagination: {},
  },
  selected: {
    profile_id: "",
    page: 1,
    per_page: 25,
    order_by: "", //name, last_modified, created_at, is_stared
    is_archived: false,
    is_active: false,
    sequence_name: "",
    sequence_tags: [],
    user_emails: [],
    people_groups: [],
  },
  inboxSelected: {
    profile_id: "",
    sequence_id: "",
    page: 1,
    per_page: 25,
    categories: [],
    sequence_step_id: "",
    channel_types: [],
    channel_email_account_id: "",
    start_date: "",
    end_date: "",
    channel_message_status_id: "",
    search_term: "",
  },
  inboxStatusSelected: {
    profile_id: "",
    sequence_id: "",
    sequence_step_id: "",
    channel_email_account_id: "",
    start_date: "",
    end_date: "",
    categories: [],
    search_term: "",
    channel_types: [],
  },
  inboxCategorySelected: {
    profile_id: "",
    sequence_inbox_category_name: "",
    sequence_step_id: "",
    channel_email_account_id: "",
    start_date: "",
    end_date: "",
    channel_message_status_id: "",
    search_term: "",
    sequence_id: "",
    channel_types: [],
  },
};
const mutations = {
  set_sequence_list_access_code(state, payload) {
    state.sequence_list_access_code = payload;
  },
  set_sequence_labels_access_code(state, payload) {
    state.sequence_labels_access_code = payload;
  },
  set_sequence_templates_access_code(state, payload) {
    state.sequence_templates_access_code = payload;
  },
  set_sequence_credentials_access_code(state, payload) {
    state.sequence_credentials_access_code = payload;
  },
  set_sequence_schedules_access_code(state, payload) {
    state.sequence_schedules_access_code = payload;
  },
  set_open_wizard(state, payload) {
    state.open_wizard = payload;
  },
  set_current_detail_sequence_info(state, payload) {
    state.current_detail_sequence_info = payload;
  },
  set_current_detail_sequence_steps(state, payload) {
    state.current_detail_sequence_steps = payload;
  },
  set_current_detail_cached_version(state, payload) {
    state.current_detail_cached_version = payload;
  },
  set_show_broken_step_save_warning_dialog(state, payload) {
    state.show_broken_step_save_warning_dialog = payload;
  },
  set_show_broken_step_disable_activation_warning_dialog(state, payload) {
    state.show_broken_step_disable_activation_warning_dialog = payload;
  },
  set_current_detail_unsaved_params_of_broken_steps(state, payload) {
    state.current_detail_unsaved_params_of_broken_steps = payload;
  },
  set_broken_step_save_confirm_callback(state, payload) {
    state.broken_step_save_confirm_callback = payload;
  },
  setSequenceRequestController(state, payload) {
    state.sequenceRequestController = payload;
  },
  setSequenceLabelRequestController(state, payload) {
    state.sequenceLabelRequestController = payload;
  },
  setSequenceLabelListLoading(state, payload) {
    state.sequenceLabelListLoading = payload;
  },
  setSequenceLabelList(state, data) {
    data ? (state.sequenceLabelList = data) : (state.sequenceLabelList = []);
  },
  setTemplateChannelsLoading(state, payload) {
    state.templateChannelsLoading = payload;
  },
  setTemplateChannels(state, data) {
    data ? (state.templateChannels = data) : (state.templateChannels = []);
  },
  setTemplateChannelsObject(state, data) {
    state.templateChannelsObject = data;
  },
  setAllTemplatesLoading(state, data) {
    state.allTemplatesLoading = data;
  },
  setAllCredentials(state, data) {
    state.allCredentials = data;
  },
  setAllCredentialsLoading(state, data) {
    state.allCredentialsLoading = data;
  },
  setAllTemplates(state, data) {
    state.allTemplates = data;
  },
  setAllTemplatesController(state, data) {
    state.allTemplatesController = data;
  },
  setCredentialChannelsLoading(state, data) {
    state.credentialChannelsLoading = data;
  },
  setCredentialChannels(state, data) {
    state.credentialChannels = data;
  },
  setNodeChannelsLoading(state, data) {
    state.nodeChannelsLoading = data;
  },
  setNodeChannels(state, data) {
    state.nodeChannels = data;
  },
  setNodeChannelsObject(state, data) {
    state.nodeChannelsObject = data;
  },
  setLoading(state, val) {
    state.sequence_loading = val;
  },
  setInboxLoading(state, val) {
    state.inboxLoading = val;
  },
  setSelected(state, val) {
    let id = parseInt(this.state.user.currentId.profile_id);
    let temp = { ...state.selected, page: 1, ...val, profile_id: id };
    if (_.isEqual(state.selected, temp)) {
      state.isStopSearch = true;
    } else {
      state.selected = temp;
    }
  },
  setInboxSelected(state, val) {
    let id = parseInt(this.state.user.currentId.profile_id);
    let temp = { ...state.inboxSelected, page: 1, ...val, profile_id: id };
    state.inboxSelected = temp;
  },
  setInboxStatusSelected(state, val) {
    let id = parseInt(this.state.user.currentId.profile_id);
    let temp = { ...state.inboxStatusSelected, ...val, profile_id: id };
    state.inboxStatusSelected = temp;
  },
  setContactStatus(state, val) {
    state.contactStatus = val;
  },
  setInboxCategorySelected(state, val) {
    let id = parseInt(this.state.user.currentId.profile_id);
    let temp = { ...state.inboxCategorySelected, ...val, profile_id: id };
    state.inboxCategorySelected = temp;
  },
  setCollapse(state, unused_data) {
    state.isShow = !state.isShow;
  },
  setSequenceList(state, data) {
    if (data) {
      state.sequenceList.seqData = data.sequences;
      state.sequenceList.pagination = data.pagination;
    } else {
      state.sequenceList = {
        seqData: [],
        pagination: {},
      };
    }
  },
  setSeqChannelTypes(state, data) {
    state.seqChannelTypes = data;
  },
  setSeqScheduleList(state, data) {
    state.scheduleList = data;
  },
  setSeqStepList(state, data) {
    state.stepsList = data;
  },
  setStepListLoading(state, data) {
    state.stepsListLoading = data;
  },
  setSeqInboxList(state, data) {
    state.inboxList = data;
  },
  setSeqInboxCategoryList(state, data) {
    state.inboxCategoryList = data;
  },
  setMessageStatus(state, data) {
    state.messageStatus = data;
  },
  setInboxStatusNum(state, data) {
    state.inboxStatusNum = data;
  },
};
const actions = {
  async fetchSequenceConfigWhenLanguageChange({ dispatch }, unused_data) {
    try {
      dispatch("getTemplateChannels");
      dispatch("getCredentialChannels");
      dispatch("getNodeChannels");
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async setEmptyWhenProfileChanges({ commit, dispatch }, { is_logout }) {
    commit("set_current_detail_sequence_info", null);
    commit("set_current_detail_sequence_steps", null);

    commit("set_current_detail_cached_version", {
      workflow: null,
      settings: null,
    });

    commit("setSequenceLabelList", []);

    commit("setTemplateChannels", []);

    commit("setTemplateChannelsObject", {});

    commit("setAllCredentials", null);
    commit("setAllTemplates", []);
    commit("setCredentialChannels", []);
    commit("setNodeChannels", []);
    commit("setNodeChannelsObject", {});

    commit("set_sequence_list_access_code", null);

    commit("set_sequence_labels_access_code", null);
    commit("set_sequence_templates_access_code", null);
    commit("set_sequence_credentials_access_code", null);
    commit("set_sequence_schedules_access_code", null);

    commit("common/set_home_market_update_news_access_code", null, {
      root: true,
    });

    commit("common/set_home_market_update_job_postings_access_code", null, {
      root: true,
    });

    commit("common/set_home_market_update_ads_access_code", null, {
      root: true,
    });

    commit("common/set_home_trending_companies_access_code", null, {
      root: true,
    });

    commit("user/set_payment_method_access_code", null, {
      root: true,
    });

    commit("user/set_billing_history_access_code", null, {
      root: true,
    });

    commit("user/set_pending_payment_access_code", null, {
      root: true,
    });
    commit("user/set_usage_access_code", null, {
      root: true,
    });
    commit("user/set_credit_history_access_code", null, {
      root: true,
    });

    commit("user/set_roles_access_code", null, {
      root: true,
    });
    commit("user/set_teams_access_code", null, {
      root: true,
    });

    commit("user/set_teams_relation_access_code", null, {
      root: true,
    });
    commit("user/set_subscription_access_code", null, {
      root: true,
    });

    commit("user/set_user_access_code", null, {
      root: true,
    });

    commit("user/set_custom_field_access_code", null, {
      root: true,
    });
    commit("user/set_api_keys_access_code", null, {
      root: true,
    });
    commit("user/set_api_keys_logs_access_code", null, {
      root: true,
    });

    commit("company/set_compaines_saved_search_access_code", null, {
      root: true,
    });
    commit("company/set_people_saved_search_access_code", null, {
      root: true,
    });
    commit("company/set_intent_saved_search_access_code", null, {
      root: true,
    });
    commit("company/set_companies_search_list_access_code", null, {
      root: true,
    });

    commit("contact/set_people_saved_list_access_code", null, {
      root: true,
    });

    commit("contact/set_companies_saved_list_access_code", null, {
      root: true,
    });

    commit("company/set_companies_detail_info_access_code", null, {
      root: true,
    });

    commit("company/set_similiar_companies_access_code", null, {
      root: true,
    });

    // commit("monitors/set_monitor_templates", null, {
    //   root: true,
    // });
    commit("monitors/set_monitor_overall_stats", null, {
      root: true,
    });
    commit("monitors/set_current_monitor_object", null, {
      root: true,
    });

    commit("contact/setCompanyList", [], { root: true });
    commit("contact/setPeopleList", [], { root: true });

    if (!is_logout) {
      dispatch(
        "common/getSequenceList",
        { forceRefresh: true },
        { root: true },
      );
    }
  },
  /** sequence template start */

  /**
   * query sequence labels
   * @param {*} context
   * @param {*} data
   */
  async getTemplateChannels(context, unused_data) {
    let unused_id = this.state.user.currentId.profile_id;
    try {
      context.commit("setTemplateChannelsLoading", true);
      const result = await SEQ.getTemplateChannelsAPI();

      const channels = result?.data || [];

      let channelsObject = {};
      channels.forEach((channel) => {
        channel?.channel_nodes.forEach((node) => {
          channelsObject[node.slug] = {
            parent_name: channel.name,
            name: node.name,
            slug: node.slug,
            description: node.description,
            logo_url: node.logo_url,
            channel_node_id: node.channel_node_id,
            parameter_properties: node.parameter_properties,
          };
        });
      });

      context.commit("setTemplateChannels", channels);
      context.commit("setTemplateChannelsObject", channelsObject);
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      context.commit("setTemplateChannelsLoading", false);
    }
  },
  async getAllTemplates({ state, commit }, unused_data) {
    try {
      if (getIsAccessDisabled(state.sequence_templates_access_code)) {
        return;
      }
      let controller = state.sequenceRequestController;
      if (controller) {
        controller.abort();
        commit("setSequenceRequestController", null);
      }
      controller = new AbortController();
      commit("setSequenceRequestController", controller);
      commit("setAllTemplatesLoading", true);
      let id = this.state.user.currentId.profile_id;
      const res = await SEQ.getTemplateFullListAPI(
        {
          profile_id: id,
        },
        {
          signal: controller?.signal,
        },
      );
      if (res && res.data) {
        commit("setAllTemplates", res.data);
      }
    } catch (error) {
      const code = error?.response?.data?.code;

      commit("set_sequence_templates_access_code", +code);
      throw error;
    } finally {
      commit("setAllTemplatesLoading", false);
    }
  },
  /** sequence template end */

  /** sequence credential channel start*/
  async getCredentialChannels(context, unused_data) {
    let unused_id = this.state.user.currentId.profile_id;
    if (context.state?.credentialChannelsLoading) {
      return;
    }
    try {
      context.commit("setCredentialChannelsLoading", true);

      const res = await SEQ.getCredentialChannelsAPI();

      context.commit("setCredentialChannels", res?.data || []);
      context.commit("setCredentialChannelsLoading", false);
    } catch (error) {
      console.log(error);
      context.commit("setCredentialChannelsLoading", false);

      throw error;
    }
  },
  async getAllCredentials(context, unused_data) {
    try {
      if (context.state?.allCredentialsLoading) {
        return;
      }
      if (getIsAccessDisabled(state.sequence_credentials_access_code)) {
        return;
      }
      context.commit("setAllCredentialsLoading", true);
      let id = this.state.user.currentId.profile_id;
      const res = await SEQ.getCredentialFullListAPI({
        profile_id: id,
      });
      if (res && res.data) {
        context.commit("setAllCredentials", res.data);
      }
      context.commit("setAllCredentialsLoading", false);
    } catch (error) {
      console.log(error);

      const code = error?.response?.data?.code;
      context.commit("set_sequence_credentials_access_code", +code);

      context.commit("setAllCredentialsLoading", false);

      throw error;
    }
  },
  /** sequence credential channel end*/

  /** sequence workflow start */
  async getNodeChannels(context, unused_data) {
    try {
      context.commit("setNodeChannelsLoading", true);
      const res = await SEQ.getNodeChannelsAPI();

      if (res && res.data) {
        context.commit("setNodeChannels", res.data);

        let _nodeChannels = {};
        res.data.forEach((level1) => {
          const { channel_types, ...restLevel1 } = level1;
          channel_types.forEach((level2) => {
            const { channel_nodes, ...restLevel2 } = level2;

            channel_nodes.forEach((level3) => {
              _nodeChannels[level3.slug] = {
                ...level3,
                level2: restLevel2,
                level1: restLevel1,
              };
            });
          });
        });
        context.commit("setNodeChannelsObject", _nodeChannels);
      }
    } catch (error) {
      console.log(error);
    } finally {
      context.commit("setNodeChannelsLoading", false);
    }
  },
  /** sequence workflow end */

  async getSequenceList({ state, commit }, data) {
    try {
      if (getIsAccessDisabled(state.sequence_list_access_code)) {
        return;
      }
      commit("setLoading", true);

      let controller = state.sequenceRequestController;
      if (controller) {
        controller.abort();
        commit("setSequenceRequestController", null);
      }
      controller = new AbortController();
      commit("setSequenceRequestController", controller);
      await commit("setSelected", data);
      const _selected = this.state.sequence.selected;
      if (!_selected.order_by) {
        delete _selected.order_by;
      }
      const handleEmptyValue = (key) => {
        if (!_selected[key] && _selected[key] !== false) {
          delete _selected[key];
        }
      };
      handleEmptyValue("is_stared");
      handleEmptyValue("is_active");
      handleEmptyValue("is_archived");

      const result = await SEQ.getSequenceList(_selected, controller.signal);
      if (result?.data) {
        commit("setSequenceList", result?.data);
        commit("setLoading", false);

        return result?.data;
      }
    } catch (error) {
      console.log(error);
      if (error?.code !== "ERR_CANCELED") {
        commit("setLoading", false);
        const code = error?.response?.data?.code;

        commit("set_sequence_list_access_code", +code);

        throw error;
      }
    }
  },
  // Read-only fetch for dropdowns / filters — uses is_full_page_search:true
   // to bypass the subscription per_page cap (was returning 416). No
   // AbortController, no setLoading spinner, no selected-state mutation.
  async getSequenceListForFilter(_, { profile_id } = {}) {
    if(!profile_id) return [];
    const res = await SEQ.getSequenceList({ profile_id, page: 1, is_full_page_search: true });
    return res?.data?.sequences || [];
  },
  async createSequences(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.createSequences({
        profile_id: id,
        ...data,
      });
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async updateSequences(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.updateSequences({
        profile_id: id,
        ...data,
      });
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async archiveSequences(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.archiveSequences({
        profile_id: id,
        ...data,
      });
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  /**
   * query sequence labels
   * @param {*} context
   * @param {*} data
   */
  async getSequenceLabelList(context, data) {
    if (getIsAccessDisabled(state.sequence_labels_access_code)) {
      return;
    }
    let controller = context.state.sequenceLabelRequestController;
    if (controller) {
      controller.abort();
      context.commit("setSequenceLabelRequestController", null);
    }
    controller = new AbortController();
    context.commit("setSequenceLabelRequestController", controller);
    let id = this.state.user.currentId.profile_id;
    try {
      context.commit("setSequenceLabelListLoading", true);
      const result = await SEQ.querySequenceLabelListAPI(
        {
          profile_id: id,
          ...data,
        },
        controller.signal,
      );
      context.commit("setSequenceLabelList", result?.data);
    } catch (error) {
      console.log(error);
      if (error?.code !== "ERR_CANCELED") {
        const code = error?.response?.data?.code;

        context.commit("set_sequence_labels_access_code", +code);

        throw error;
      }
    } finally {
      context.commit("setSequenceLabelListLoading", false);
    }
  },

  /**
   * add labels to one sequence
   * @param {*} context
   * @param {*} data
   * @returns
   */
  async addLabelsToSequence(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.addLabelsToSequenceAPI({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      if (error?.code !== "ERR_CANCELED") {
        throw error;
      }
    }
  },
  /**
   * remove labels frome one sequence
   * @param {*} context
   * @param {*} data
   * @returns
   */
  async removeLabelsFromSequence(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.removeLabelsFromSequenceAPI({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      if (error?.code !== "ERR_CANCELED") {
        throw error;
      }
    }
  },
  async getSeqChannelTypes(context) {
    try {
      const result = await SEQ.getSeqChannelTypes();
      context.commit("setSeqChannelTypes", result?.data);
    } catch (error) {
      console.log(error);
      if (error?.code !== "ERR_CANCELED") {
        throw error;
      }
    }
  },
  /*-----------------schedule--------------------*/
  async getSeqScheduleList(context, unused_data) {
    if (getIsAccessDisabled(state.sequence_schedules_access_code)) {
      return;
    }
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.getSeqScheduleList({
        profile_id: id,
      });
      context.commit("setSeqScheduleList", result?.data);
    } catch (error) {
      console.log(error);
      const code = error?.response?.data?.code;

      context.commit("set_sequence_schedules_access_code", +code);
      throw error;
    }
  },
  /*-----------------sequence-account-email--------------------*/
  async getSeqAccountEmailList(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.getSeqAccountEmailList({
        profile_id: id,
        ...data,
      });
      context.commit("setSeqAccountEmailList", result?.data);
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  /*-----------------sequence-steps--------------------*/
  async getSeqStepList(context, data) {
    let id = this.state.user.currentId.profile_id;
    context.commit("setStepListLoading", true);
    try {
      const result = await SEQ.getSeqStepList({
        profile_id: id,
        ...data,
      });
      context.commit("setSeqStepList", result?.data);
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      context.commit("setStepListLoading", false);
    }
  },
  /*-----------------sequence-contact--------------------*/

  async getContactStatus(context) {
    try {
      const result = await SEQ.getContactStatus();
      context.commit("setContactStatus", result?.data);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  /*-----------------sequence-inbox--------------------*/
  async getSeqInboxList(context, data) {
    const { params, signal } = data;

    context.commit("setInboxLoading", true);
    context.commit("setInboxSelected", params);
    try {
      const result = await SEQ.getSeqInboxList(
        this.state.sequence.inboxSelected,
        signal,
      );
      context.commit("setSeqInboxList", result?.data);
      return result?.data;
    } catch (error) {
      console.log(error);
      if (error.code !== "ERR_CANCELED") {
        throw error;
      }
    } finally {
      context.commit("setInboxLoading", false);
    }
  },
  async getSeqInboxMeta(context, data) {
    let unused_id = this.state.user.currentId.profile_id;
    context.commit("setInboxStatusSelected", data);
    try {
      const result = await SEQ.getSeqInboxMeta(
        this.state.sequence.inboxStatusSelected,
      );
      context.commit("setInboxStatusNum", result?.data);
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async lookupSeqInbox(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.lookupSeqInbox({
        profile_id: id,
        ...data,
      });
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async getMessageStatus(context) {
    let unused_id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.getMessageStatus();
      context.commit("setMessageStatus", result?.data);
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async deleteInbox(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.deleteInbox({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  /*------------------inbox category-------------------*/
  async getSeqInboxCategoryList(context, data) {
    context.commit("setInboxCategorySelected", data);
    try {
      const result = await SEQ.getSeqInboxCategoryList(
        this.state.sequence.inboxCategorySelected,
      );
      context.commit("setSeqInboxCategoryList", result?.data);
      return result?.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async createSeqInboxCategory(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.createSeqInboxCategory({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async deleteSeqInboxCategory(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.deleteSeqInboxCategory({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async addSeqToCategory(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.addSeqToCategory({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async exportSeqInboxFull(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.exportSeqInboxFull({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  async exportSeqInboxPartial(context, data) {
    let id = this.state.user.currentId.profile_id;
    try {
      const result = await SEQ.exportSeqInboxPartial({
        profile_id: id,
        ...data,
      });
      return result;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
